<template>
  <v-container fluid>
    <h1>
      <v-icon>mdi-chart-donut</v-icon>หวยรอการออกผล
    </h1>

    <v-card :disabled="on_update || loading" :loading="on_update || loading">
      <v-card-title>หวยรอการออกผล</v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>หมวดหมู่</th>
                <th>หวย</th>
                <th>วันที่/เวลา</th>
                <th>เลขที่ออก</th>
                <th>4 ตัวบน</th>
                <th>3 ตัวบน</th>
                <th>2 ตัวบน</th>
                <th>2 ตัวล่าง</th>
                <th>จัดการ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-show="loading">
                <td colspan="9" class="text-center">
                  <v-progress-circular indeterminate color="primary" class="my-2"></v-progress-circular>
                  <p>กำลังโหลดข้อมูลกรุณารอสักครู่...</p>
                </td>
              </tr>
              <tr v-show="!loading && result_list.length == 0">
                <td colspan="9" class="text-center">ไม่พบข้อมูลในระบบ</td>
              </tr>
              <tr v-show="!loading" v-for="r in result_list" :key="r.id">
                <td>{{ r.cate_name }}</td>
                <td>{{ r.name }}</td>
                <td>{{ r.result_time }}</td>
                <td>{{ r.result || "-" }}</td>
                <td>{{ r.four_result || "-" }}</td>
                <td>{{ r.three_result || "-" }}</td>
                <td>{{ r.two_up_result || "-" }}</td>
                <td>{{ r.two_down_result || "-" }}</td>
                <td>
                  <v-btn small color="primary" @click="selectLottoForUpdate(r.result_id)">
                    <v-icon>mdi-update</v-icon>เปลี่ยนผล
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="show_confirm_update" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">ยืนยันการเปลี่ยนแปลงผลหวย?</v-card-title>
        <v-card-text>กรุณาตรวจสอบรายการหวยทุกครั้ง</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="show_confirm_update = false">ยกเลิก</v-btn>
          <v-btn color="green darken-1" text @click="updateLotto">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="on_update" hide-overlay persistent disabled width="320">
      <v-card color="primary" dark>
        <v-card-text>
          กำลังเปลี่ยนแปลงผลกรุณารอสักครู่...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import moment from "moment-timezone";
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => {
    return {
      loading: true,
      on_update: false,
      show_confirm_update: false,
      r_id: null,
    };
  },
  computed: {
    ...mapGetters("lottoResult", ["result_list"]),
  },
  created() {
    document.title = "หวยรอการออกผล";

    this.loadWaitingResults();
  },
  methods: {
    ...mapActions("lottoResult", ["getWaitinResults", "updateResult"]),
    async loadWaitingResults() {
      this.loading = true;
      try {
        const data = await this.getWaitinResults();
        if (data.success && data.success === true) {
          this.$notify({
            type: "success",
            title: "สำเร็จ",
            text: "โหลดข้อมูลเรียบร้อย",
          });
        } else if (!data.success && data.message) {
          this.$notify({
            type: "error",
            title: "Error",
            text: data.message,
          });
        } else {
          this.$notify({
            type: "error",
            title: "Error",
            text: "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง",
          });
        }
      } catch (err) {
        const errMsg =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
          err.message ||
          "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง";
        this.$notify({
          type: "error",
          title: "Error",
          text: errMsg,
        });
      }
      this.loading = false;
    },
    selectLottoForUpdate(r_id) {
      this.r_id = r_id;
      this.show_confirm_update = true;
    },
    async updateLotto() {
      if (!this.r_id) return false;
      this.show_confirm_update = false;
      this.on_update = true;
      try {
        const data = await this.updateResult(this.r_id);

        if (data.success && data.success === true) {
          this.$notify({
            type: "success",
            title: "สำเร็จ",
            text: "อัพเดทผลหวยใหม่เรียบร้อย",
          });
        } else if (!data.success && data.message) {
          this.$notify({
            type: "error",
            title: "Error",
            text: data.message,
          });
        } else {
          this.$notify({
            type: "error",
            title: "Error",
            text: "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง",
          });
        }
        this.loadWaitingResults();
      } catch (err) {
        const errMsg =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
          err.message ||
          "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง";
        this.$notify({
          type: "error",
          title: "Error",
          text: errMsg,
        });
      }
      this.on_update = false;
    },
  },
};
</script>
